export function uuid() {
  return (
    '_' +
    Math.random()
      .toString(36)
      .substr(2, 9)
  )
}

export function stringToDom(str) {
  const parser = new DOMParser()
  return parser.parseFromString(str, 'text/html')
}

export function removeProtocol(url) {
  return url.replace(/^https?:\/\//, '')
}

export function getFavicon(url) {
  return `https://www.google.com/s2/favicons?domain=${url}`
}

export function ellipsis(str, length = 100) {
  return str && str.length > length ? str.substring(0, length) + '...' : str
}

/**
 * Export functions
 */

function _arrayToCSV(arr) {
  const items = arr
  // Specify how you want to handle null values here
  const replacer = (key, value) => (value === null ? '' : value)
  const header = Object.keys(items[0])
  let csv = items.map(row =>
    header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','),
  )
  csv.unshift(header.join(','))
  csv = csv.join('\r\n')

  return csv
}

function _exportData(data, exportName, extension) {
  const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(data)
  const downloadAnchorNode = document.createElement('a')
  downloadAnchorNode.setAttribute('href', dataStr)
  downloadAnchorNode.setAttribute('download', exportName + '.' + extension)
  document.body.appendChild(downloadAnchorNode) // required for firefox
  downloadAnchorNode.click()
  downloadAnchorNode.remove()
}

export function downloadObjectAsCSV(exportObj, exportName) {
  const csv = _arrayToCSV(exportObj)

  _exportData(csv, exportName, 'csv')
}

export function downloadObjectAsJson(exportObj, exportName) {
  const json = JSON.stringify(exportObj, null, 2)

  return _exportData(json, exportName, 'json')
}



// WEBPACK FOOTER //
// ./util/index.js